<script setup lang="ts">
import { computed } from "vue";
import { OrderDetail, SlimOrder } from "@/types/order/Order";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import SimpleOrderListItem from "@/components/molecules/orders/SimpleOrderListItem.vue";
const DISPLAY_ORDER_COUNT = 3;
const props = defineProps<{
  orderDetail: OrderDetail;
  applicableOrders: SlimOrder[] | null;
}>();

const orderListLink = computed(() => ({
  name: "SearchByOffice",
  params: {
    officeId: `${props.orderDetail.office.id}`
  },
  hash: "#orderList"
}));
const otherApplicableOrders = computed(() =>
  props.applicableOrders?.filter(order => order.id !== props.orderDetail.id)
);
const otherApplicableOrderCount = computed(
  () => otherApplicableOrders.value?.length || 0
);
const isShow = computed(() => {
  return otherApplicableOrderCount.value > 0;
});
const isShowOrderListLink = computed(() => {
  return otherApplicableOrderCount.value > DISPLAY_ORDER_COUNT;
});
</script>

<template>
  <div v-if="isShow">
    <div class="p-3 bg-white border-top border-bottom border-gray-03">
      <h3 class="text-size-14 text-weight-500 text-primary-dark">
        その他の応募日時
      </h3>

      <div class="mt-3">
        <div class="order-list">
          <SimpleOrderListItem
            :order="order"
            :key="order.id"
            class="d-block"
            v-for="order in otherApplicableOrders?.slice(
              0,
              DISPLAY_ORDER_COUNT
            )"
          />
        </div>
        <RouterLink
          v-if="isShowOrderListLink"
          class="order-list-link"
          :to="orderListLink"
          data-testid="order-list-link"
        >
          <span
            class="order-list-link-text"
            data-testid="order-list-link-text"
            >{{ `他の募集日時を見る (全${otherApplicableOrderCount}件)` }}</span
          >
          <FeatherIcon icon="chevron-right" size="24" />
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.order-list-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  margin-top: 20px;
  color: #118ab2;
  cursor: pointer;
  border: 2px solid #118ab2;
  border-radius: 4px;
}

.order-list-link-text {
  font-size: 14px;
  font-weight: 500;
  color: #118ab2;
}

.operation-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: center;
  align-items: center;
  margin-top: 8px;
}

.chevron-icon {
  margin-left: auto;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
}
</style>
